module.exports = __webpack_public_path__ + "static/media/siddharth-coorg-trip-11.358663ac.png";